import React from "react";
import PropTypes from "prop-types";

const FormTextEntry = ({ label = "", placeholder = "", fieldType = "", name = "", autocomplete, value = "", saveChanges = f => f, disabled = false }) => {
    let autocompleteAttr;
    let fieldError = name + "Error";
    if (autocomplete) {
        autocompleteAttr = {autoComplete: autocomplete};
    }
    return (
        <div>
            <label className="formText w3-text-blue w3-animate-opacity">
                <b>{label}</b>
            </label>
            <input
                type={fieldType}
                className="textEntry w3-input w3-border w3-round-large"
                name={name}
                placeholder={placeholder}
                value={value}
                {...autocompleteAttr}
                disabled={disabled}
                onChange={evt => saveChanges(name, evt.target.value)}
            />
            <div id={fieldError} className="w3-text-red w3-small"></div>
        </div>
    );
}

FormTextEntry.propTypes = {
    label: PropTypes.string,
    placeholder: PropTypes.string,
    name: PropTypes.string,
    saveChanges: PropTypes.func
};

export default FormTextEntry;
